import { motion } from "framer-motion";

//STYLES
import { PG } from "./style";
import { transition_default } from "../../../../../../utils";
import { DonutChartSvg } from "./components/chart";

//PROPS
interface Props {
    dados_progresso: [number, number, number] | number[]
}

export const ProgressoGeral: React.FC<Props> = ({ dados_progresso }) => {

    //STATES
    

    return (
        <PG
            initial={{opacity: 0, y: 30}}
            animate={{opacity: 1, y: 0}}
            transition={{...transition_default}}
        >
            <p className="PG__title">Progresso Geral</p>
            
            <div className="PG__chart">
                <DonutChartSvg values={dados_progresso} />
            </div>
            {/* <DonutChart size={140} thickness={22} valuhes={dados_progresso??[]} cornerRadius={11.3} /> */}

            <div className="PG__labels">
                <div className="PG__labels__item">
                    <div className="PG__labels__item__circle"  style={{background: "#7ebd61"}}/>
                    <span className="PG__labels__item__lebel">Concluído</span>
                </div>
                <div className="PG__labels__item">
                    <div className="PG__labels__item__circle"/>
                    <span className="PG__labels__item__lebel">Em progresso</span>
                </div>
                <div className="PG__labels__item">
                    <div className="PG__labels__item__circle" style={{background: "#F5F5F5"}} />
                    <span className="PG__labels__item__lebel">Não iniciado</span>
                </div>
            </div>

        </PG>
    )
};